import React from "react";
import ListView from "./component";

const List: React.FC = (props: any) => {
    return <ListView />;
};

export default List;